import { el } from 'redom';

import { getDefaultInputValue } from '../utilities';
import { cloneOperator, getOperatorsByField } from '../operator-selector/utilities';
import { getInitialValue } from './utilities';

import FieldInputAnchor from '../field-input-anchor';
import OperatorInputAnchor from '../operator-input-anchor';
import ValuesSelector from '../values-selector';

class CriteriaBuilder {

  constructor(options) {

    this.fieldSelector = options.fieldSelector;
    this.operatorSelector = options.operatorSelector;
    this.criteria = options.criteria;
    this.onChange = options.onChange;
    this.previousOperator = cloneOperator(this.criteria.operator);

    this.fieldInputAnchor = null;
    this.operatorInputAnchor = null;
    this.valuesSelector = null;

    this.initializeFieldInputAnchor();
    this.initializeOperatorInputAnchor();
    this.initializeValuesSelector();

    this.el = el('.criteria-builder-main', [this.fieldInputAnchor, this.operatorInputAnchor, this.valuesSelector]);

  }

  initializeFieldInputAnchor() {

    const options = {
      field: this.fieldSelector.getFieldByKey(this.criteria.field.key),
      fieldSelector: this.fieldSelector,
      onSelect: this.handleFieldInputChange.bind(this),
      onClose() {}
    };

    this.fieldInputAnchor = new FieldInputAnchor(options);

  }

  initializeOperatorInputAnchor() {

    const options = {
      operator: this.criteria.operator,
      field: this.fieldSelector.getFieldByKey(this.criteria.field.key),
      operatorSelector: this.operatorSelector,
      onSelect: this.handleOperatorChange.bind(this),
      onClose() {}
    };

    this.operatorInputAnchor = new OperatorInputAnchor(options);

  }

  initializeValuesSelector() {

    const options = {
      fieldSelector: this.fieldSelector,
      criteria: this.criteria,
      onChange: this.handleValuesChange.bind(this),
      onClose() {}
    };

    this.valuesSelector = new ValuesSelector(options);

  }

  handleFieldInputChange(field) {

    const fieldOperators = getOperatorsByField(field);

    this.criteria.operator = cloneOperator(fieldOperators[0]);
    this.criteria.field = this.fieldSelector.getFieldByKey(field.key);
    this.criteria.value = getDefaultInputValue(this.criteria.operator);

    this.operatorInputAnchor.onFieldChange(this.criteria);
    this.valuesSelector.onFieldChange(this.criteria);

    this.onChange(this.criteria);

  }

  handleOperatorChange(operator) {

    this.previousOperator = this.criteria.operator;
    this.criteria.operator = operator;

    this.criteria.value = getInitialValue(this.criteria.operator, this.previousOperator, this.criteria.value);

    this.valuesSelector.onOperatorChange(this.criteria);

    this.onChange(this.criteria);

  }

  handleValuesChange(value) {

    this.criteria.value = value;

    this.onChange(this.criteria);

  }

  focusInput() {

    this.fieldInputAnchor.anchor.handleAnchorButtonClick();

  }

}

export default CriteriaBuilder;